import { useMemo, useContext } from 'react';

import UserRoleContext from 'context/user-role/context';

import { arrayValidation } from 'utils/array';

import { ACTION_KEYS, SCREENS_KEYS } from 'constants/constants';

type Permission = 'allow' | 'deny';

const useUserActionAccess = (
  screenKey: (typeof SCREENS_KEYS)[keyof typeof SCREENS_KEYS],
  actionKey: (typeof ACTION_KEYS)[keyof typeof ACTION_KEYS],
  defaultPermission: Permission = 'deny',
) => {
  const { isSuperAdmin, userAccess } = useContext(UserRoleContext);

  const hasAccess = useMemo(() => {
    if (isSuperAdmin) return true;

    // Si no hay configuración/carga de overrides, por seguridad NO damos acceso.
    if (!arrayValidation(userAccess)) return false;

    const override = userAccess.find(
      (item) => item.screenKey === screenKey && item.actionKey === actionKey,
    );

    // Sin override explícito, se hereda el permiso default (por defecto deny)
    if (!override) return defaultPermission === 'allow';

    return (override.permission as Permission) === 'allow';
  }, [isSuperAdmin, userAccess, screenKey, actionKey, defaultPermission]);

  return { hasAccess, disabled: !hasAccess };
};

export default useUserActionAccess;
